import produce from "immer";
import {
  LookupState,
  LookupActionTypes,
  LOAD_LOOKUP_SUCCESS,
  RESET_LOOKUP_DATA
} from "./types";

const initialState: LookupState = {};

const lookupReducer = produce(
  (draft: LookupState, action: LookupActionTypes) => {
    switch (action.type) {
      case LOAD_LOOKUP_SUCCESS: {
        draft[action.route] = action.data;
        return;
      }
      case RESET_LOOKUP_DATA: {
        delete draft[action.route];
        return;
      }
    }
  },
  initialState
);

export default lookupReducer;
